export enum DropTypes {
    simple = 'simple',
    complex = 'complex',
    none = 'none',
}

export default DropTypes;
